<template>
  <v-row no-gutters>
    <v-col>
      <v-card>
        <v-card-text class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Таскомбанк"
            clearable
            :loading="loading"
            btn-label="Отримати"
            :search-field="false"
            @add="getData"
          >
            <template v-slot:filters>
              <v-row class="px-1 py-0">
                <v-col
                  cols="5"
                  class="py-0"
                >
                  <DateRangePicker
                    :start.sync="startDate"
                    :end.sync="endDate"
                    :filled="false"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:totals>
              <v-row no-gutters>
                <v-spacer />
                <v-col
                  cols="3"
                  class="d-flex justify-end"
                >
                  <v-card-text class="subtitle-1 text-right pa-0">
                    Сумма:&nbsp;
                  </v-card-text>
                  <v-card-text class="title text-right pa-0 pr-4">
                    {{ totalAmount | decimal }}
                  </v-card-text>
                </v-col>
              </v-row>
            </template>
          </DataListHeading>
        </v-card-text>
      </v-card>

      <SimpleTable
        :headers="headers"
        :loading="loading"
        :items-per-page="rowsCount"
        :items="items"
        display-pagination
      />
    </v-col>
  </v-row>
</template>

<script>
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import SimpleTable from "@/components/story/SimpleTable";
import headers from "./headers.js";
import * as integrationsApi from "@/backend/integrationsApi.js";
import DataListHeading from "@/components/DataListHeading.vue";
import moment from "moment";
moment.locale("uk");

export default {
  components: {
    DateRangePicker,
    SimpleTable,
    DataListHeading,
  },
  data: () => ({
    startDate: "",
    endDate: "",
    items: [],
    loading: false,
    page: 1,
  }),
  computed: {
    headers() {
      return headers;
    },
    totalAmount() {
      return (
        this.items &&
        this.items.reduce((acc, item) => {
          return acc + +item.sum;
        }, 0)
      ) || 0;
    },
    rowsCount() {
      return Math.floor((window.innerHeight - 300) / 55);
    },
    isDatesFilled() {
      return this.endDate && this.startDate;
    },
  },
  watch: {
    isDatesFilled() {
      this.getData();
    },
  },
  created() {
    this.endDate = this.moment().format("YYYY-MM-DD");
    this.startDate = this.moment().subtract(2, "days").format("YYYY-MM-DD");
  },
  methods: {
    async getData() {
      this.loading = true;
      this.items = await integrationsApi.fetchTascombankTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
      });
      this.loading = false;
    },
  },
};
</script>
